/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileDescription16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8.062 1a1.5 1.5 0 01.99.374l.112.109L11.488 4H13.5A1.5 1.5 0 0115 5.5v5a1.5 1.5 0 01-1.5 1.5H12v1.5a1.5 1.5 0 01-1.356 1.493L10.5 15h-8a1.5 1.5 0 01-1.493-1.356L1 13.5v-11a1.5 1.5 0 011.356-1.493L2.5 1h5.562zm0 1H2.5a.5.5 0 00-.492.41L2 2.5v11a.5.5 0 00.41.492L2.5 14h8a.5.5 0 00.492-.41L11 13.5V12H5.5A1.5 1.5 0 014 10.5v-5A1.5 1.5 0 015.5 4h4.628L8.43 2.16a.5.5 0 00-.285-.153L8.062 2zm2.918 3H5.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5H11v.141a.5.5 0 00-.02-.14zm.52 3.5a.5.5 0 110 1h-4a.5.5 0 010-1h4zm0-2a.5.5 0 110 1h-4a.5.5 0 010-1h4z"
        />
    </AccessibleSVG>
);

export default FileDescription16;
